module.exports = __webpack_public_path__ + "static/banner1-db2bc4760ff673f1db09f04968f4c669.png";